export default __webpack_public_path__ + "static/media/Carrusel_05.89929208.png";